import * as React from 'react';
import { Col, Row } from 'react-grid-system';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import styles from './DealerImprintModal.styl';
import FormTextArea from '../../../ui/FormTextArea/FormTextArea';
import ModalHeader from '../ModalHeader/ModalHeader';
import form, { fieldsNames } from '../../../pages/DealerPages/forms/DealerProfileForm';
const col12 = 12;
const col8 = 8;
const col4 = 4;
class DealerImprintModal extends React.PureComponent {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "onTakeExisting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, language, template: { email, street, number, streetAddition, city, zip, phoneMain, commercialRegister, commercialRegisterNumber, authorizedRepresentative, company, fax, ustIdNr } } = this.props;
                const formattedPhoneNumber = `${phoneMain.countryCode || ''}${phoneMain.areaCode || ''}${phoneMain.phoneNumber || ''}`;
                const formattedFaxNumber = (fax.countryCode && fax.areaCode && fax.phoneNumber) ? `${fax.countryCode}${fax.areaCode}${fax.phoneNumber}` : '';
                const lines = [
                    `${company}`,
                    ``,
                    `${[street, number, streetAddition].filter(Boolean).join(' ')}`,
                    `${zip} ${city}`,
                    ``,
                    `${t('text.imprint.template.phoneMain', { lng: language })}: ${formattedPhoneNumber}`,
                    `${t('label.fax', { lng: language })}: ${formattedFaxNumber}`,
                    `${t('text.imprint.template.email', { lng: language })}: ${email}`,
                    ``,
                    `${t('text.imprint.template.comReg', { lng: language })}: ${commercialRegister}`,
                    `${t('text.imprint.template.comRegNumber', { lng: language })}: ${commercialRegisterNumber}`,
                    ``,
                    `${t('label.ustIdNr', { lng: language })}: ${ustIdNr}`,
                    `${t('text.imprint.template.authorized', { lng: language })}: ${authorizedRepresentative}`
                ];
                form.$(fieldsNames.imprint).$(language).set(lines.join('\n'));
            }
        });
        Object.defineProperty(this, "onDecline", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.props.hideModal('DEALER_IMPRINT_MODAL');
            }
        });
        Object.defineProperty(this, "onSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                form.$(fieldsNames.imprint).submit().then(({ isValid }) => {
                    if (isValid) {
                        this.props.hideModal('DEALER_IMPRINT_MODAL');
                    }
                });
            }
        });
    }
    render() {
        const { t, language, template } = this.props;
        const field = form.$(fieldsNames.imprint);
        const languageField = field.$(language);
        languageField.resetValidation();
        return (React.createElement(Row, { className: styles.wrapper },
            React.createElement(Col, { xs: col12, className: styles.textHeader },
                React.createElement(ModalHeader, { t: t, field: field })),
            React.createElement(Col, { xs: col12, md: col8, className: styles.colTakeImprint },
                React.createElement(Button, { variant: 'outlined', disabled: !template, className: styles.buttonTake, onClick: this.onTakeExisting }, t('ui.button.takeImprint')),
                !template && React.createElement("div", { className: styles.textWarning }, t('message.warning.imprint.emptyTemplate'))),
            React.createElement(Col, { xs: col12, md: col8 },
                React.createElement(FormTextArea, { t: t, field: languageField, className: styles.textArea, containerClassName: styles.textAreaHeight, fieldClassName: styles.textAreaHeight, showPlaceholder: true })),
            React.createElement(Col, { xs: col12, md: col4 },
                React.createElement(Row, { nogutter: true, className: styles.rowFields },
                    React.createElement(Col, { xs: col12 },
                        React.createElement("div", { className: styles.textTitleFields },
                            React.createElement("b", null, t('text.imprint.desc.title'))),
                        React.createElement("div", null, t('text.imprint.desc.general.0')),
                        React.createElement("br", null),
                        React.createElement("div", null, t('text.imprint.desc.general.1')),
                        React.createElement("br", null),
                        React.createElement("div", null, t('text.imprint.desc.general.2')),
                        React.createElement("br", null),
                        React.createElement("div", null, t('text.imprint.desc.general.3'))))),
            React.createElement(Col, { xs: col12, md: col8 },
                React.createElement("div", { className: styles.blockModalButton },
                    React.createElement(Button, { variant: 'outlined', className: styles.button, onClick: this.onDecline }, t('ui.button.discard')),
                    React.createElement(Button, { variant: 'filled', className: styles.button, onClick: this.onSave }, t('ui.button.save.imprint'))))));
    }
}
export default DealerImprintModal;
